export default "__VITE_ASSET__943ba619__"